import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { LangContext } from "../LangContext.jsx";
class DossierPendingToSignDocumentsTable extends Component {
    static contextType = LangContext;
    constructor(props) {
        super(props);
        this.state = {
            documents: props.documents,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.documents !== prevProps.documents) {
            this.setState({ documents: this.props.documents });
        }
    }

    handleDeleteDoc2SignDocumentClick = async (event, fileId, documentId) => {
        event.preventDefault();

        await this.deleteDoc2SignDocument(fileId, documentId);
    }

    async deleteDoc2SignDocument(fileId, documentId) { 
        window.blockUI();

        try {
            const response = await axios.delete(`/api/files/${fileId}`);

            if (response.status === 204) {
                let docs = this.state.documents;
                const updatedDocs = docs.filter(doc => doc.id !== documentId);

                this.setState({ documents: updatedDocs });
            }
        } catch (error) {
            swal.fire({
                title: 'El documento ha sido firmado',
                text: 'La acción de eliminar no podra realizarse cuando el documento ya ha sido firmado por al menos un firmante.',
                icon: 'warning',
                width: 650,
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: 'btn font-weight-bold btn-light-primary',
                }
            })
        } finally {
            window.unblockUI();
        }
    }

    render() {
        const { lang } = this.context; 
        return (
            <>
                <tr>
                    <td colSpan="5">
                        <div className="separator separator-solid separator-border-1 mt-5 mb-2" style={{ borderBottomColor: "#dbcbfd" }}></div>
                        <h5 className="py-5">{this.props.title}</h5>
                    </td>
                </tr>
                {this.state.documents?.map((d, i) => (
                <tr key={i}>
                    <td style={{width: "20px"}}>
                        <img src="/assets/img/doc2sign.svg"/>
                    </td>
                    <td colSpan="2">
                        {`${d.document.title} ${d.document.version > 1 ? `V${d.document.version}` : ''}`}
                        <div className="text-dark-65 font-size-sm">
                            ( {lang.get('messages.solicitado_el')} { d.requestedDate })
                        </div>

                    </td>
                    <td colSpan="2" className="text-right">
                        <img src="/assets/img/doc2sign-logo.png" className="w-70px mr-3"/>

                        <div className="dropdown dropdown-inline">
                            <a href="#" className="btn btn-fixed-height btn-primary font-weight-bolder font-size-sm px-5" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {lang.get('messages.acciones')}
                                &nbsp;&nbsp;
                                <i className="flaticon2-down icon-sm"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 m-0 rounded-lg" style={{ background: '#F0E9FF' }}>
                                <ul className="navi navi-hover">
                                    <li className="navi-item">
                                        <a href="" onClick={(e) => this.handleDeleteDoc2SignDocumentClick(e, d.file_id, d.id)} className="navi-link py-4">
                                            <i className="icon-md mr-2 text-primary flaticon2-trash"></i>
                                            <span className="navi-text text-secondary">{lang.get('messages.eliminar')}</span>
                                            <span className="navi-icon pull-right">
                                                <button className="btn btn-icon btn-light btn-xs bg-white">
                                                    <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                </button>
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </td>
                </tr>
                ))}
            </>
        );
    }
}

export default DossierPendingToSignDocumentsTable;

if (document.getElementById('DossierPendingToSignDocumentsTable')) {
    ReactDOM.render(<DossierPendingToSignDocumentsTable />, document.getElementById('DossierPendingToSignDocumentsTable'));
}
